var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDmp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_544_28245)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_544_28245)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12.0001,
    r: 9.5,
    fill: "#2D99C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.44566 4.29327C8.87105 4.51562 11.2516 5.33964 13.345 6.76535L3.62422 16.4861C3.31258 15.9053 3.05958 15.2884 2.87312 14.6433L10.3115 7.20493C8.48549 6.39165 6.50808 6.02705 4.54622 6.1111C5.09204 5.42119 5.7316 4.80884 6.44566 4.29327Z",
    fill: "#FFDF37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.66568 18.0382L16.5875 6.11644L16.3711 8.92675L5.96259 19.3352C5.48979 18.9456 5.05532 18.5111 4.66568 18.0382Z",
    fill: "#FFDF37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.51459 20.3768L17.2355 10.6559C18.6615 12.7497 19.4856 15.1306 19.7077 17.5564C19.1921 18.2704 18.5797 18.91 17.8897 19.4557C17.974 17.4935 17.6094 15.5157 16.7959 13.6894L9.35729 21.1281C8.71218 20.9416 8.09531 20.6885 7.51459 20.3768Z",
    fill: "#FFDF37"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_544_28245",
    x: -1.5,
    y: 2.50012,
    width: 27,
    height: 27,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_544_28245"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_544_28245",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_544_28245"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDmp);
export default __webpack_public_path__ + "static/media/DMP.472edf384d70609f13ecc89d02979961.svg";
export { ForwardRef as ReactComponent };